import { Grid } from 'src/domains/shared/components/Grid';
import { Text } from '@hawkins/components';

export const OutputProperty = ({
  label,
  value,
}: {
  label: string;
  value: string;
  isBold?: boolean;
}) => (
  <Grid columns="70% 30%">
    <Text bold>{label}:</Text>
    <Text align="right">{value}</Text>
  </Grid>
);
